// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCNSCFylbkKGjbnP00EPYYogoxD2w93JCc",
  authDomain: "ecovanguard-webapp.firebaseapp.com",
  projectId: "ecovanguard-webapp",
  storageBucket: "ecovanguard-webapp.appspot.com",
  messagingSenderId: "386830761676",
  appId: "1:386830761676:web:90990815df96caca3d4c69",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
